import { cloneElement } from "react";
import { Box } from "@mui/material";
import { StyledTableCell } from "../style";

export default function Actions({ components, ...args }) {
  return (
    <StyledTableCell {...args} align="center">
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          gap: 0.25,
          // Finger-friendly action buttons on touch devices (icon buttons are
          // 36px by default, below the 44px minimum).
          "@media (max-width: 768px)": {
            gap: 0.5,
            "& .MuiButtonBase-root": { minWidth: 44, minHeight: 44 },
          },
        }}
      >
        {components?.map((Action, index) => cloneElement(Action, { key: index }))}
      </Box>
    </StyledTableCell>
  );
}
